import { FieldType } from '@ngx-formly/material';
import { Subject } from 'rxjs';

import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';

import {
  ISnRadialSliderFormFieldConfig,
  ISnRadialSliderFieldTemplateOptions,
} from '@lib/form/radial-slider';

@Component({
  selector: 'sn-radial-slider-form-field',
  templateUrl: './radial-slider.field-type.html',
})
export class SnRadialSliderFormField
  extends FieldType<ISnRadialSliderFormFieldConfig>
  implements OnInit, OnDestroy
{
  public defaultOptions: ISnRadialSliderFormFieldConfig = {
    type: 'radial',
    templateOptions: {
      hideFieldUnderline: true,
    },
  };

  private readonly _destroy$ = new Subject<void>();

  constructor() {
    super();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  get templateOptions(): ISnRadialSliderFieldTemplateOptions {
    return this.field.templateOptions;
  }

  public onAngleChange(angle: number): void {
    if (this.to.change) {
      this.to.change(this.field, angle);
      this.formControl.setValue(angle);
    }
  }
}
